<template>
    <v-text-field
        v-model="valueLocal"
        :label="field.titleSingular"
        :rules="field.rules"
        :readonly="isReadonly"
        :required="field.isRequired"
        :counter="field.maxLength"
        :dense="isDense"
        :disabled="isDisabled" />
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: null,
        },
        field: {
            type: Object,
            default: null,
        },
        isEdit: {
            type: Boolean,
            default: false,
        },
        filter: {
            type: Object,
            default: null,
        },
        isDense: {
            type: Boolean,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        isReadonly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        valueLocal: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
};
</script>
